// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import copy07Icon from "@/assets/icons/copy-07.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Copy07IconProps = Omit<IconProps, "name">;

export function Copy07Icon(props: Copy07IconProps): React.ReactNode {
  return <Icon name={copy07Icon} {...props} />;
}
